import { WandSparkles } from "lucide-react";
import React from "react";

import Button from "../../lib/ui/components/button/Button";
import { SmallText, XsmallText } from "../../lib/ui/components/typography/Typography";

const SetupJobBanner = ({ onSetup, onSkip, isRunning, documentCount }) => (
    <div
        className="flex items-center gap-4 px-4 py-4 bg-purple-50 border border-purple-200 rounded-lg"
        data-cy="setup-job-banner"
    >
        <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-white border border-purple-200 shrink-0">
            <WandSparkles className="text-primary" size={20} />
        </span>
        <div className="flex-1">
            <SmallText weight="bold" emphasis={true}>This role hasn't been set up yet</SmallText>
            <XsmallText>
                Add the role context and any documents below, then set up the role. We'll write the interview
                questions, their scoring, score caps and overall-rating guidance — all editable afterwards. Bypass
                rules are always yours to add manually. Or set the
                role up yourself and skip the AI entirely.
                {documentCount > 0 && ` ${documentCount} document${documentCount === 1 ? "" : "s"} will be read.`}
            </XsmallText>
        </div>
        <div className="flex items-center gap-3 shrink-0">
            <button
                type="button"
                onClick={onSkip}
                disabled={isRunning}
                className="text-body font-medium text-gray-600 hover:text-gray-900 hover:underline disabled:opacity-50"
                data-cy="skip-job-setup-button"
            >
                Set up manually
            </button>
            <Button
                variant="primary"
                onClick={onSetup}
                disabled={isRunning}
                leftIcon={<WandSparkles size="1em" />}
                data-cy="setup-job-button"
            >
                {isRunning ? "Setting up..." : "Setup Job"}
            </Button>
        </div>
    </div>
);

export default SetupJobBanner;
